// extracted by mini-css-extract-plugin
module.exports = {"title":"TermsAndConditions_title__1k8rB","terms-and-conditions":"TermsAndConditions_terms-and-conditions__2WGdz","list":"TermsAndConditions_list__3ngxr"};